var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFutbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1765 28.575L26.0333 40H38.117L41.826 28.5775L32.0563 21.5125L22.1765 28.575ZM31.9436 0C14.3502 0 0 14.325 0 32C0 49.675 14.3502 64 32.0563 64C49.7625 64 64 49.675 64 32.1125C64 14.55 49.7625 0 31.9436 0ZM54.4958 45.1375L41.4854 44.9403L37.6449 57.3802C35.838 57.775 33.9722 58 32.0563 58C30.1405 58 28.2759 57.7784 26.4765 57.3838L22.6398 44.95L9.62065 45.1375C7.75111 41.9688 6.51644 38.3862 6.13953 34.5475L16.8171 27.05L12.6097 14.7625C15.0953 11.97 18.1594 9.70625 21.6305 8.185L32.0563 16L42.4859 8.19125C45.957 9.7125 49.0212 11.975 51.5068 14.7688L47.2956 27.05L57.9681 34.5462C57.4886 38.3875 56.3616 41.975 54.4958 45.1375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFutbol);
export default __webpack_public_path__ + "static/media/futbol.310d7065dd6cce61ff9e7273dd897ac0.svg";
export { ForwardRef as ReactComponent };